import { render, staticRenderFns } from "./ListMergeModal.vue?vue&type=template&id=08af3263&scoped=true"
import script from "./ListMergeModal.vue?vue&type=script&lang=js"
export * from "./ListMergeModal.vue?vue&type=script&lang=js"
import style0 from "./ListMergeModal.vue?vue&type=style&index=0&id=08af3263&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08af3263",
  null
  
)

export default component.exports